export enum DashboardActionTypes {
    API_RESPONSE_SUCCESS = '@@dashboard/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR   = '@@dashboard/API_RESPONSE_ERROR',

    GET_DASHBOARDS       = '@@dashboard/GET_DASHBOARDS',
    GET_DASHBOARD_BY_ID  = '@@dashboard/GET_DASHBOARD_BY_ID',
    CREATE_DASHBOARD     = '@@dashboard/CREATE_DASHBOARD',
    UPDATE_DASHBOARD     = '@@dashboard/UPDATE_DASHBOARD',
    DELETE_DASHBOARD     = '@@dashboard/DELETE_DASHBOARD',

    RESET                = '@@dashboard/RESET',
}
